"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var takeField = exports.takeField = function takeField(arr, field) {
    return arr.map(function (x) {
        return field ? x[field] : x;
    });
};

var takeLast = exports.takeLast = function takeLast(arr, n, field) {
    return takeField(arr.slice(n > arr.length ? 0 : arr.length - n, arr.length), field);
};

var sum = exports.sum = function sum(data) {
    return data.reduce(function (acc, x) {
        return acc + x;
    });
};

var mean = exports.mean = function mean(data) {
    return data.reduce(function (a, b) {
        return a + b;
    }) / data.length;
};

var stddev = exports.stddev = function stddev(data) {
    var dataMean = mean(data);
    var sqDiff = data.map(function (n) {
        return Math.pow(n - dataMean, 2);
    });
    var avgSqDiff = mean(sqDiff);
    return Math.sqrt(avgSqDiff);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@binary-com/binary-indicators/lib/math.js
// module id = 158
// module chunks = 0